'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('\\', fromIndex);
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-parse/lib/locate/escape.js
// module id = 1369
// module chunks = 168707334958949